import { TActionType, TransactionType } from "../../../Utility/Tracking/DataSet/Transaction";
import { trackTransaction } from "../../../Utility/Tracking/TrackingHelpers/Transaction";
import { IGameState } from "../../Game/IGameState";
import { IChestUnlock, UnlockType } from "../IPlayerState";
import { setBoosterJoker, setBoosterTNT, setCoins, setLives } from "../PlayerInventoryHelper";

export function unlockChest(state: IGameState, chestID: string): IGameState {
    // Validate this chest has not already been unlocked.
    if (
        state.playerState.playerUnlocks.find(
            (unlock: IChestUnlock) =>
                unlock.type === UnlockType.CHEST && unlock.id === chestID
        )
    ) {
        return state;
    }

    // Get chestNumber from ID in format: chest_{chestNumber}
    const chestSplit = chestID.split('_');
    const chestNumber = (parseInt(chestSplit[1]) - 1) % 3;

    let playerState = state.playerState;
    switch (chestNumber) {
        case 0:
            playerState = setCoins(playerState, playerState.coins + 200);
            playerState = setLives(playerState, playerState.lives + 1);
            break;
        case 1:
            playerState = setCoins(playerState, playerState.coins + 300);
            playerState = setLives(playerState, playerState.lives + 2);
            playerState = setBoosterJoker(
                playerState,
                playerState.inventory.boosterJoker + 1
            );
            break;
        case 2:
            playerState = setCoins(playerState, playerState.coins + 500);
            playerState = setLives(playerState, playerState.lives + 3);
            playerState = setBoosterTNT(
                playerState,
                playerState.inventory.boosterTNT + 1
            );
            break;
    }

    trackTransaction(state, TransactionType.REWARD, TActionType.REWARD);

    return {
        ...state,
        playerState: {
            ...playerState,
            playerUnlocks: [
                ...state.playerState.playerUnlocks,
                {
                    type: UnlockType.CHEST,
                    id: chestID,
                },
            ],
        },
    };
}
